// src/redux/slices/filterSlice.js
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FilterState {
  searchQuery: string;
  selectedSpecialty: string;
  zipCode: string;
  location: string;
  insurance: string;
  sessionRate: string;
  sessionType: string;
  ageRanges: string[];
  therapyModalities: string[];
  languages: string[];
  faithSpirituality: string;
  paymentMethods: string[];
  currentPage: number;
}

const initialState: FilterState = {
  searchQuery: '',
  selectedSpecialty: '',
  zipCode: '',
  location: '',
  insurance: '',
  sessionRate: '',
  sessionType: '',
  ageRanges: [],
  therapyModalities: [],
  languages: [],
  faithSpirituality: '',
  paymentMethods: [],
  currentPage: 1
};

const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    setSelectedSpecialty: (state, action: PayloadAction<string>) => {
      state.selectedSpecialty = action.payload;
    },
    setZipCode: (state, action: PayloadAction<string>) => {
      state.zipCode = action.payload;
    },
    setLocation: (state, action: PayloadAction<string>) => {
      state.location = action.payload;
    },
    setInsurance: (state, action: PayloadAction<string>) => {
      state.insurance = action.payload;
    },
    setSessionRate: (state, action: PayloadAction<string>) => {
      state.sessionRate = action.payload;
    },
    setSessionType: (state, action: PayloadAction<string>) => {
      state.sessionType = action.payload;
    },
    setAgeRanges: (state, action: PayloadAction<string[]>) => {
      state.ageRanges = action.payload;
    },
    setTherapyModalities: (state, action: PayloadAction<string[]>) => {
      state.therapyModalities = action.payload;
    },
    setLanguages: (state, action: PayloadAction<string[]>) => {
      state.languages = action.payload;
    },
    setFaithSpirituality: (state, action: PayloadAction<string>) => {
      state.faithSpirituality = action.payload;
    },
    setPaymentMethods: (state, action: PayloadAction<string[]>) => {
      state.paymentMethods = action.payload;
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    resetFilters: () => initialState,
    // Bulk update action for setting multiple filters at once
    updateFilters: (state, action: PayloadAction<Partial<FilterState>>) => {
      return { ...state, ...action.payload };
    }
  }
});

export const {
  setSearchQuery,
  setSelectedSpecialty,
  setZipCode,
  setLocation,
  setInsurance,
  setSessionRate,
  setSessionType,
  setAgeRanges,
  setTherapyModalities,
  setLanguages,
  setFaithSpirituality,
  setPaymentMethods,
  setCurrentPage,
  resetFilters,
  updateFilters
} = filterSlice.actions;

export default filterSlice.reducer;